export { default } from './PageTitle';



// WEBPACK FOOTER //
// ./src/routes/Admin/PageTitle/index.ts